import React from 'react';
import { Layout, Badge, Button, Space } from 'antd';
import { LogoutOutlined, MenuOutlined } from '@ant-design/icons';
import { useAuthStore } from '@/stores/authStore';

const { Header } = Layout;

interface AppHeaderProps {
  pageTitle: string;
  onMenuClick?: () => void;
  immersive?: boolean;
}

const AppHeader: React.FC<AppHeaderProps> = ({ pageTitle, onMenuClick, immersive }) => {
  const { user, setUser } = useAuthStore();

  const handleLogout = () => {
    setUser(null);
    window.location.href = '/login';
  };

  const headerClassName = immersive ? 'app-header app-header--immersive' : 'app-header';

  return (
    <Header
      className={headerClassName}
      style={{
        background: immersive ? undefined : '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        boxShadow: immersive ? undefined : '0 1px 2px rgba(0,0,0,0.03)',
        position: 'sticky',
        top: 0,
        zIndex: 99,
      }}
    >
      <Space>
        {onMenuClick && (
          <Button type="text" icon={<MenuOutlined />} onClick={onMenuClick} style={{ marginRight: 8 }} />
        )}
        <span className="app-header__title" style={immersive ? undefined : { fontSize: 18, fontWeight: 600, color: '#374151' }}>{pageTitle}</span>
      </Space>
      <Space>
        {user && (
          <>
            <Badge
              count={user.role === 'admin' ? '管理员' : '访客'}
              style={{ backgroundColor: user.role === 'admin' ? '#0d9488' : '#9ca3af' }}
            />
            <span className="app-header__username" style={immersive ? undefined : { color: '#374151' }}>{user.username}</span>
            <Button type="text" icon={<LogoutOutlined />} onClick={handleLogout}>
              退出
            </Button>
          </>
        )}
      </Space>
    </Header>
  );
};

export default AppHeader;
